import React, {useEffect,useState, useRef} from 'react';
import Axios from "/plugins/axios";
// import ReactJWPlayer from 'react-jw-player';
import Head from 'next/head';
import TagManager from 'react-gtm-module';
import PlaylistCarousel from '/components/VideoDetail/PlaylistCarousel';
import WidgetJwPlaylistPlayer from '/components/widgetJwPlaylistPlayer';
import ClapprPlayer from '/components/Clappr/ClapprPlayer';
import {isFacebookApp} from '/utils/common'

// import Slider from "react-slick";
const tagManagerArgs = {
    // gtmId: 'GTM-WCJSTPT',
    dataLayer: {
      userId: '001',
      userProject: 'project',
      CRMAuthor: 'CRMAuthor',
      Section: 'Section',
      articlePublishedDate: 'articlePublishedDate',
  }
}

 const SectionVideoPlaylistWidget = (props) => {
    const [data, setData] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState('');
    const [showTitle, setShowTitle] = useState(false);
    const [currentTitle, setCurrentTitle] = useState('');
    const [currentSlug, setCurrentSlug] = useState('');
    const [currentPlayerId, setCurrentPlayerId] = useState('');
    const [sliderCurrent, setSliderCurrent] = useState();
    const slider = useRef();
    const targetOrigin = process.env.IS_LOCALHOST ? 'http://localhost' + (process.env.PORT ? ':'+process.env.PORT : '') : process.env.BACKEND_URL;
    let perPage = props.url.query.perPage ? props.url.query.perPage : 5;

    useEffect(() => {
        let mounted = true;
        let type = props.url.query.type ? props.url.query.type : 'latest';
        let categoriesParam = props.url.query.categories ? `&categories=${props.url.query.categories}` : '';
        let tagsParam = props.url.query.tags ? `&tags=${props.url.query.tags}` : '';
        let apiUrl = `/videos/${type}?widget=1&perPage=${perPage}${categoriesParam}${tagsParam}`;
        Axios.get(apiUrl)
        .then(res => {
            if(mounted){
                setLoaded(true);
                setData(res.data.data);
                setSliderCurrent(slider.current)
                window.parent.postMessage(res.data.data && res.data.data.length !== 0 ? 'isContent' : 'noContent', `${targetOrigin}`);

                if(res.data.data && res.data.data.length !== 0){
                    const queryId = props.url.query.videoId ? props.url.query.videoId : res.data.data[0].slug;
                    let video = res.data.data.find(item => item.slug == queryId);
                    tagManagerArgs.dataLayer.CRMAuthor = video.author ? video.author.name : 'Undefined';
                    tagManagerArgs.dataLayer.Section = 'videos';
                    tagManagerArgs.dataLayer.articlePublishedDate = video.published_date.date;
                    if(video.campaign || isFacebookApp() ){
                        tagManagerArgs.dataLayer.utmCampaign = video.campaign ? video.campaign.utm_campaign : "duwun-video-playlist-widget";
                        tagManagerArgs.dataLayer.utmContent = video.campaign ? video.campaign.utm_content : 'Undefined';
                        tagManagerArgs.dataLayer.utmMedium = video.campaign ? video.campaign.utm_medium : 'social';
                        tagManagerArgs.dataLayer.utmSource = video.campaign ? video.campaign.utm_source : 'facebook';
                        tagManagerArgs.dataLayer.utmTerm = video.campaign ? video.campaign.utm_term : 'Undefined';
                    }
                    // else if (isFacebookWebApp()){
                    //     tagManagerArgs.dataLayer.utmCampaign = video.campaign ? video.campaign.utm_campaign : 'duwun-video-playlist-widget';
                    //     tagManagerArgs.dataLayer.utmMedium = video.campaign ? video.campaign.utm_medium : 'social';
                    //     tagManagerArgs.dataLayer.utmSource = video.campaign ? video.campaign.utm_source : 'facebook';                        
                    // }
                    // else {

                    // }
                    TagManager.dataLayer(tagManagerArgs);

                    if(window.self === window.top) {// I'm not in iframe
                        // TagManager.dataLayer(tagManagerArgs)
                    }
                }
            }
        })
        .catch(err => {
            window.parent.postMessage('noContent', `${targetOrigin}`)
            setError(err.message);
            setLoaded(true);
        });

        return () => {
            mounted = false;
        };
    }, []);
    if (loaded) {
        if(error){
            return (
                <h3 style={{ textAlign: 'center' }}>{error}</h3>
            )
        }
        else if( data && data.length !== 0) {
            const queryId = props.url.query.videoId ? props.url.query.videoId : data[0].slug;
            let videoIndex = data && data.length > 0 && data.findIndex((item, index) => item.slug == queryId);
            const playlistPos = data ? data.findIndex((item, i)=> item.slug == queryId) + 1 : null;
            const urlVideoId = props.url.query.videoId ? props.url.query.videoId : null;
            const currentItem = urlVideoId ? data[videoIndex] : data[0];
            const envPlayer = process.env.WIDGET_PAGE_PLAYER && process.env.WIDGET_PAGE_PLAYER.toLowerCase();
            let parentPath = props.url.query.postId ? (props.url.query.categories ? "/"+props.url.query.categories.replace(",", "/")+"/" : "/") + props.url.query.postId : "";
            let poster = urlVideoId ? data[videoIndex].posters && data[videoIndex].posters.thumb : data[0].posters && data[0].posters.thumb;
            let video_url = urlVideoId ? data[videoIndex].video_url : data[0].video_url;
            let customProps = null;
            const jwPlayerId =  props.url && props.url.query.playerId ? props.url.query.playerId : currentItem.jwplayer_id;
            if(currentItem){
                customProps = {
                    ga: {
                        label: currentItem && currentItem.title ? currentItem.title : 'No Title'
                    }
                };
                if ( !currentItem.no_ads ) {
                    if ( currentItem.ad_tag ) // set custom AdTag
                        customProps.advertising = {
                            client: "googima",
                            tag: currentItem.ad_tag
                        };
                }
                else { //inject empty AdTag
                    customProps.advertising = {
                        tag: ''
                    };
                }
                customProps.floating = !currentItem.ad_tag;
            }
            return (
                <React.Fragment>
                <Head>
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                    <link rel="stylesheet" type="text/css" charSet="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
                    <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
                    <link href="/static/css/widgetStyle.css" rel="stylesheet" />
                </Head>
                <div style={{ position: 'relative' }} id="clapprPlaylistWidget">
                    <>
                    {   envPlayer === 'jwplayer' ?
                            <WidgetJwPlaylistPlayer
                                poster={poster}
                                source={video_url}
                                parentPath={parentPath}
                                upNext={data[playlistPos]}
                                data={data}
                                slickGoToProp={sliderCurrent}
                                playlistPos={playlistPos}
                                currentItem={currentItem}
                                routeName="sectionVideoPlaylistWidget"
                                routeParams={{videoId: data[playlistPos] ? data[playlistPos].slug: ''}}
                                isSectionVideoPlaylist={true}
                                customProps={customProps}
                                jwPlayerId={jwPlayerId}
                            />
                            :
                            <ClapprPlayer
                                id="widget-clappr-player-latest"
                                width="100%"
                                height="calc(100vw * 0.5625)"
                                autoPlay
                                poster={poster}
                                source={video_url}
                                video={currentItem}
                                upNext={data[playlistPos]}
                                playlist={data}
                                slickGoToProp={sliderCurrent}
                                playlistPos={playlistPos}
                                routeName="sectionVideoPlaylistWidget"
                                routeParams={{videoId: data[playlistPos] ? data[playlistPos].slug: ''}}
                                isWidget
                            />
                    }
                        <PlaylistCarousel
                          playlistItems={data}
                          queryId={queryId}
                          routeName={'sectionVideoPlaylistWidget'}
                          slider={slider}
                          slickGoToProp={sliderCurrent}
                          categoriesParam={props.url.query.categories ? props.url.query.categories : ''}
                          tagsParam={props.url.query.tags ? props.url.query.tags : ''}
                          perPage={perPage}
                          isSectionPlaylistWidget={true}
                          currentItem={currentItem}
                         />
                    </>
               </div>
               </React.Fragment>
            );
        }
        else{ return <h3>There is no video for this playlist.</h3> };
    } else {
        return (
            <div>
                Loading widget: playlist...
                <div className="placeholderbox">
                  <div className="banner-holder"></div>
                  <hr className="hr-box" />
                  <span className="title-holder text-group"></span>
                  <div className="text-group p-holder"></div>
                  <div className="text-group"></div>
                </div>
            </div>
        );
    }
};
export default SectionVideoPlaylistWidget;
